import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  toggle(e) {
    const enabled = this.element.getAttribute("aria-checked") === "true"
    this.element.setAttribute("aria-checked", (!enabled).toString())
  }
}